<template>
  <div class="template" data-type="template">
    <div
      v-show="!S_GlobalSearch"
      v-if="dataArray['template']"
      style="padding-bottom: 100px; position: relative; padding-top: 2px"
      ref="list"
    >
      <!-- 分类筛选 -->
      <div class="pad" v-show="slideState && dataMsg == 'template'"></div>
      <DropDownMenu
        v-show="slideState && dataMsg == 'template'"
        all="全部"
        :isShow="isShowDropDownMenu"
        :options="category"
        :selectedIndex="selectedCateIndex"
        :myStyle="{
          position: 'fixed',
          /* 挡住星星按钮 */
          zIndex: 101,
          top: '160px',
        }"
        @clickItem="selectCategory"
        ref="dropDownMenu"
      ></DropDownMenu>
      <!-- <CategoryPicker :category="category" @changedCategory="selectCategory"></CategoryPicker> -->

      <!-- 横竖分类 -->
      <div
        v-show="false"
        class="optimized"
        style="
          width: 130px;
          zindex: 151;
          width: 0;
          height: 0;
          zindex: -1;
          overflow: hidden;
        "
        :style="`top: ${optimizedTop}px`"
        ref="optimizedRef"
      >
        <div class="pointer" :class="{ right: optimized !== 1 }"></div>
        <div
          style="width: 65px"
          :class="{
            horizontal: true,
            hover: optimized == 1 ? false : true,
            active: optimized == 1,
          }"
          @click="
            optimized = 1;
            materialPushAnalysis({ type: 'sceneLandscape' });
          "
        >
          横版
        </div>
        <div
          style="width: 65px"
          :class="{
            Vertical: true,
            hover: optimized == 2 ? false : true,
            active: optimized == 2,
          }"
          @click="
            optimized = 2;
            materialPushAnalysis({ type: 'scenePortrait' });
          "
        >
          竖版
        </div>
      </div>

      <!-- 权限筛选 -->
      <FilterSprites
        v-if="false"
        v-model="dataArray['template']"
        :boxName="boxName"
        :cgid="'template'"
        :dataArray="dataArray"
        :loading="loading"
        :classes="['small', 'no-transition']"
        :style="`top: ${filterSpritesTop}px;`"
        ref="filterSpritesRef"
      />

      <div
        class="item"
        v-for="(itemL, indexL) in dataArray['template'].data"
        @mouseover="getCharacters($event, itemL)"
        @mouseout="closeCharacters()"
        :key="indexL"
        @click="addTemplate(itemL)"
        :style="{
          top: itemL.topWFC + 'px',
          left: itemL.leftWFC + 'px',
          height: itemL.direction
            ? itemL.direction == 2
              ? '223px'
              : '75px'
            : '75px',
          width: itemL.direction
            ? itemL.direction == 2
              ? '130px'
              : '130px'
            : '130px',
        }"
      >
        <img
          :src="$handleAssetsUrl(itemL.thumbnailUrl)"
          :style="{
            height: '100%',
            width: itemL.direction
              ? itemL.direction == 2
                ? '100%'
                : 'auto'
              : 'auto',
          }"
        />

        <!-- <span
          class="label"
          :class="[
                'price-tag_' + itemL.id
            ]"
          v-if="itemL.tt"
          style="width: auto; padding: 0 3px;"
        >已购买</span> -->

        <!-- v-if="itemL.payType && !UserEquity.exclusive && !itemL.tt" -->
        <!-- <span
          class="label"
          :class="[
                'price-tag_' + itemL.id
            ]"
          v-if="itemL.payType && (!UserEquity.exclusive || isPersonVip) && !itemL.tt"
          style="width: auto; padding: 0 3px;"
        >¥ {{itemL.price}}</span> -->
        <payType-subscript
          :item="itemL"
          style="right: 4px; bottom: 4px"
        ></payType-subscript>

        <el-tooltip
          effect="dark"
          content="收藏"
          placement="top"
          :open-delay="1000"
        >
          <i
            class="collection_sprite_icon"
            :class="[
              { collection_sprite_icon_active: itemL.f },
              'vipResource_' + itemL.id,
            ]"
            @mouseover="
              collectionSpriteIconTit($event);
              stopDocument($event);
            "
            @click="
              stopDocument($event);
              collectionSpriteIconFS(itemL, $event);
            "
          ></i>
        </el-tooltip>
      </div>

      <div
        v-loading="loading"
        v-if="loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        element-loading-text="加载中..."
        element-loading-spinner="el-laihua-loading"
        style="width: 100%; height: 20px; margin-top: 37px"
      ></div>

      <div class="more-template" v-show="slideState && dataMsg == 'template'">
        <div class="btn" @click="callSpriteLib({ category: selectedCateId })">
          更多模板
        </div>
      </div>
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="addTemplate"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Analysis from "../../mixins/analysis/materialBu";
import Search from "./search/search";
import DropDownMenu from "../controls/menu";
import CategoryPicker from "../controls/templateCategoryPicker.vue";
import PayTypeSubscript from "@/components/common/templatePayTypeSubscript";

export default {
  mixins: [rightnavSlide, Analysis],
  data() {
    return {
      boxName: "template", // 素材盒子的名字
      dataArray: [], // 数据数组
      scollTop: {
        // 控制滚动条的数据
        default: 60, // 默认添加的高度 - 38(横竖版按钮高度)
        Incremental: 140, // 单个分类的高度
        material: 90, // 单个元素的高度
      },
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 8, //'home/template',
        sOfPage: 24,
        fPage: 24,
        style: null,
      },
      user: true, // 判断是否含有user块
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 2, // 瀑布流的列数
        default: 120, // 默认添加的高度
        oldDefault: 120,
      },
      previewData: [
        {
          name: "推荐",
          data: "11",
          type: "static",
        },
        {
          name: "最新",
          data: "0",
          type: "dynamic",
        },
      ],
      filterSpritesTop: 2,
      optimizedTop: 0,
      tid: 0,
      selectedCateIndex: -1,
      selectedCateId: "",
      isShowDropDownMenu: true,
    };
  },
  props: ["dataMsg"],
  computed: {
    ...mapGetters([
      "S_GlobalSearch",
      "S_Scenes",
      "StyleMsg",
      "Window_Size",
      "SelectScenes_Msg",
      "IsVipSprites",
      "UserMsg",
      "isPersonVip",
    ]),
  },
  watch: {
    "dataArray.template"(val) {
      let hArr = { 1: 90, 2: 233 };
      let rows = Math.ceil((val.data || []).length / 2);
      let filterSectionHeight = 30;
      this.$refs.list.style.height =
        rows * hArr[this.optimized] + filterSectionHeight + 120 + "px";
    },
  },
  created() {
    this.$bus.on("template.payDone", (id) => {
      this.$analysis("resource_area,can_use_template,素材资源区_解锁_模板");
      // let list = this.dataArray['template'].data;
      // list.some(v => {
      //   if (v.id === id) {
      //     this.$set(v, 'payType', 0);
      //     $('.price-tag_' + id).html('已购买');
      //     return true;
      //   }
      // })
      this.selectCategory();
    });
  },
  mounted() {
    const changeTop = (data) => {
      this.filterSpritesTop = data.scrollTop + 2;
      this.optimizedTop = data.scrollTop + 0;
    };
    let oldT = 0;
    // this.$bus.on("rightSlideBoxBroadcast_vue", (data)=>{
    //   this.setFixed();
    // });

    // $(window).on('resize', () => {
    //   this.setFixed();
    // })
  },
  methods: {
    collectScenes() {
      // 收藏元素
      this.$bus.emit("collectPersonal_vue", { data: "scenesSetting" });
    },
    getPayState(itemL) {
      let isVip = itemL.payType && !UserEquity.exclusive;
      let paid = itemL.tt;
      let state = "free";
      // let text = '';
      if (paid) {
        state = "paid";
        // text = '已购买'
      } else if (isVip) {
        state = "needPay";
        // text = '¥ ' + itemL.price
      }

      return {
        state,
      };
    },
    mapPayText(itemL) {
      let map = {
        paid: "已购买",
        needPay: "¥ " + itemL.price,
      };
    },
    setFixed() {
      let rect = $(".RightNav .msgBox>.slides")[0].getBoundingClientRect();
      this.$refs.filterSpritesRef &&
        $(this.$refs.filterSpritesRef.$el).css({
          position: "fixed",
          top: rect.top + 2,
          left: rect.left,
        });
      $(this.$refs.optimizedRef).css({
        position: "fixed",
        top: rect.top,
        left: rect.left,
      });
    },
    unsetFixed() {
      this.$refs.filterSpritesRef &&
        $(this.$refs.filterSpritesRef.$el).css({
          position: "absolute",
          top: 2,
          left: 0,
        });
      $(this.$refs.optimizedRef).css({
        position: "absolute",
        top: 0,
        left: 0,
      });
    },
    selectCategory(index) {
      if (index == null) {
        index = this.selectedCateIndex;
      }
      this.$set(this.dataArray.template, "data", []);
      let cate = this.category[index] || {};
      this.selectedCateId = cate.id || "";
      this._getData(cate.id || "template", 1);
      this.selectedCateIndex = index;
      this.$bus.emit("rightSlideBoxScrollTop_vue", {
        type: "template",
        scrollTop: 0,
      });
    },
    // selectCategory(cate) {
    //   console.log(JSON.stringify(cate));
    //   if (cate == null) {
    //     //index = this.selectedCateIndex;
    //     cate = {};
    //   }
    //   this.$set(this.dataArray.template, "data", []);
    //   //let cate = this.category[index] || {};
    //   this._getData(cate.id || "template", 1);
    //   //this.selectedCateIndex = index;
    //   this.$bus.emit("rightSlideBoxScrollTop_vue", {
    //     type: "template",
    //     scrollTop: 0
    //   });
    // }
  },
  components: {
    Search,
    DropDownMenu,
    CategoryPicker,
    PayTypeSubscript,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.template {
  width: 270px;
  // border-radius: 8px;
  position: relative;
  // border-top: 2px solid #d4d4e7;

  .optimized {
    // width: 268px;
    // height: 38px;
    // background: #f0f0f8;
    margin: 0 auto;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;

    width: 130px;
    height: 38px;
    background-color: #fafafd;
    border-radius: 4px;
    border: solid 1px #dbdff0;

    .horizontal,
    .Vertical {
      width: 134px;
      height: 38px;
      position: absolute;
      color: #000;
      text-align: center;
      line-height: 38px;
      top: 0;
      transition: all 0.3s;
    }
    .horizontal {
      left: 0;
    }
    .Vertical {
      right: 0;
    }
    .active {
      // background: #5778fb;
      color: #fff;
    }
    // .hover{
    //   &:hover{
    //     background: #95a8f3;
    //   }
    // }
  }

  .add-scenes {
    width: 100%;
    height: 75px;
    cursor: pointer;

    > div {
      height: 35px;
      width: 60%;
      margin: 0 auto;
      margin-top: 27px;
      background: rgb(146, 148, 193);
      border-radius: 35px;
      text-indent: 30px;
      text-align: left;
      line-height: 35px;
      color: #fff;
    }
  }
  section {
    width: 270px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #474261;
    right: 0;
    margin-bottom: 5px;
    background: #fff;
    img {
      width: 270px;
      height: 90px;
      background-color: #87307e;
      border-radius: 8px;
      margin-bottom: 9px;
      cursor: pointer;
    }
    .expand-line {
      width: 270px;
      height: 16px;
      background-color: #ccc;
    }
  }

  .item {
    width: 130px;
    height: 75px;
    border-radius: 3px;
    background: #b7b7b7;
    position: absolute;
    border: 2px solid #eaeaf5;
    overflow: hidden;
    cursor: pointer;

    &:hover {
      border-color: #5778fb;
    }
    > img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
    }

    .modify,
    .label {
      position: absolute;
      bottom: 5px;
      right: 5px;
      width: 30px;
      height: 18px;
      background: #d83d60;
      color: #fff;
      border-radius: 5px;
      line-height: 18px;
    }
    .modify {
      width: 35px;
      height: 35px;
      opacity: 0;
      cursor: pointer;
      transition: all 0.3s;
      background-image: url("../../../../static/svg/edit-display-white.svg");
      background-size: 20px 18px;
      background-repeat: no-repeat;
      background-position: center;
    }
    &:hover {
      .modify {
        opacity: 1;
      }
    }
  }

  .fix-section-top {
    // position: fixed;
    top: 130px;
    right: 82px;
    z-index: 10;
    transition: all 0.3s;
  }
}

.pointer {
  width: 65px;
  height: 38px;
  background-color: #5778fb;
  border-radius: 4px;
  position: absolute;
  top: -1px;
  left: -1px;
  transition-duration: 0.3s;

  &.right {
    left: 65px;
  }
}

@import "./slide.scss";
.more-template {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  width: 270px;
  height: 90px;
  text-align: center;
  z-index: 300;
  pointer-events: none;
  & > .btn {
    @include bottom-more-btn();
    pointer-events: all;
  }
}

.pad {
  position: fixed;
  top: 150px;
  width: 270px;
  height: 64px;
  background-color: #fff;
  z-index: 101;
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/template.vue